/**
 * Conseiller Beauté IA — Esthetica
 * Ce fichier gère uniquement l'interface du chat côté navigateur.
 * Les clés API (OpenAI, Shopify) ne sont JAMAIS ici — elles sont sur le backend Vercel.
 */

(function () {
  'use strict';

  var BACKEND_URL  = 'https://esthetica-ai.vercel.app/api/chat';
  var SESSION_KEY  = 'lea_session'; // clé sessionStorage

  // ============================================================
  // Éléments du DOM
  // ============================================================
  var widget      = document.getElementById('ai-advisor-widget');
  var toggle      = document.getElementById('ai-advisor-toggle');
  var panel       = document.getElementById('ai-advisor-panel');
  var messages    = document.getElementById('ai-advisor-messages');
  var input       = document.getElementById('ai-advisor-input');
  var sendBtn     = document.getElementById('ai-advisor-send');
  var closeBtn    = panel ? panel.querySelector('.ai-advisor-header__close') : null;
  var suggestions = document.getElementById('ai-advisor-suggestions');

  if (!widget || !toggle || !panel) return;

  // ============================================================
  // État
  // ============================================================
  var isOpen    = false;
  var isLoading = false;
  var history   = [];   // contexte OpenAI
  var msgLog    = [];   // journal visuel (pour sessionStorage)

  // ============================================================
  // Session persistante — survit à la navigation entre pages
  // ============================================================
  function sauvegarderSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        history: history,
        msgs:    msgLog,
      }));
    } catch (e) {}
  }

  function restaurerSession() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var session = JSON.parse(raw);
      if (!session.msgs || session.msgs.length === 0) return;

      history = session.history || [];
      messages.innerHTML = ''; // vider le message de bienvenue hardcodé avant restauration
      if (suggestions) suggestions.style.display = 'none';

      session.msgs.forEach(function (item) {
        if (item.type === 'products') {
          renderProduits(item.products);
        } else {
          renderMessage(item.role, item.text, item.isError);
        }
      });
      scrollToBottom();
    } catch (e) {}
  }

  // ============================================================
  // Ouvrir / Fermer le panneau
  // ============================================================
  function openPanel() {
    isOpen = true;
    panel.classList.add('ai-advisor--open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    var iconOpen  = toggle.querySelector('.ai-advisor-toggle__icon--open');
    var iconClose = toggle.querySelector('.ai-advisor-toggle__icon--close');
    if (iconOpen)  iconOpen.style.display  = 'none';
    if (iconClose) iconClose.style.display = 'flex';
    if (input) input.focus();
    scrollToBottom();
  }

  function closePanel() {
    isOpen = false;
    panel.classList.remove('ai-advisor--open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    var iconOpen  = toggle.querySelector('.ai-advisor-toggle__icon--open');
    var iconClose = toggle.querySelector('.ai-advisor-toggle__icon--close');
    if (iconOpen)  iconOpen.style.display  = 'flex';
    if (iconClose) iconClose.style.display = 'none';
  }

  toggle.addEventListener('click', function () {
    if (isOpen) { closePanel(); } else { openPanel(); }
  });

  if (closeBtn) closeBtn.addEventListener('click', closePanel);

  document.addEventListener('click', function (e) {
    if (isOpen && !widget.contains(e.target)) closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closePanel();
  });

  // ============================================================
  // Suggestions rapides
  // ============================================================
  if (suggestions) {
    suggestions.addEventListener('click', function (e) {
      var btn = e.target.closest('.ai-advisor-suggestion');
      if (!btn) return;
      var question = btn.dataset.question;
      if (question) {
        suggestions.style.display = 'none';
        sendMessage(question);
      }
    });
  }

  // ============================================================
  // Gestion du champ de saisie
  // ============================================================
  if (input) {
    input.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 100) + 'px';
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSend();
      }
    });
  }

  if (sendBtn) sendBtn.addEventListener('click', handleSend);

  function handleSend() {
    if (!input) return;
    var text = input.value.trim();
    if (!text || isLoading) return;
    input.value = '';
    input.style.height = 'auto';
    sendMessage(text);
  }

  // ============================================================
  // Envoi d'un message et appel au backend
  // ============================================================
  function sendMessage(text) {
    appendMessage('user', text);
    history.push({ role: 'user', content: text });
    if (history.length > 10) history = history.slice(history.length - 10);
    sauvegarderSession(); // sauvegarder immédiatement — avant la réponse du backend

    var typingEl = appendTyping();
    setLoading(true);

    fetch(BACKEND_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ message: text, history: history }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.error || 'Erreur serveur (' + res.status + ')');
          });
        }
        return res.json();
      })
      .then(function (data) {
        removeTyping(typingEl);
        setLoading(false);
        if (data.ia) {
          appendMessage('bot', data.ia);
          history.push({ role: 'assistant', content: data.ia });
        }
        if (data.widget && data.widget.products && data.widget.products.length > 0) {
          appendProducts(data.widget.products);
        }
        sauvegarderSession();
      })
      .catch(function (err) {
        removeTyping(typingEl);
        setLoading(false);
        appendMessage('bot', "Désolée, une erreur est survenue. Veuillez réessayer dans quelques instants.", true);
        console.warn('[Esthetica AI Advisor] Erreur:', err.message);
      });
  }

  // ============================================================
  // Rendu des messages (séparé du log pour la restauration)
  // ============================================================
  function renderMessage(role, text, isError) {
    var div = document.createElement('div');
    div.className = 'ai-advisor-message ai-advisor-message--' + role;
    if (isError) div.classList.add('ai-advisor-message--error');
    var bubble = document.createElement('div');
    bubble.className = 'ai-advisor-message__bubble';
    bubble.innerHTML = role === 'bot' ? renderMarkdown(text) : escapeHtml(text).replace(/\n/g, '<br>');
    div.appendChild(bubble);
    messages.appendChild(div);
    return div;
  }

  function renderProduits(products) {
    var div = document.createElement('div');
    div.className = 'ai-advisor-message ai-advisor-message--bot';
    var bubble = document.createElement('div');
    bubble.className = 'ai-advisor-message__bubble';

    var title = document.createElement('div');
    title.style.cssText = 'font-size:12px;color:#8B5A6E;margin-bottom:8px;font-weight:600;';
    title.textContent = 'Produits disponibles chez Esthetica :';
    bubble.appendChild(title);

    var list = document.createElement('div');
    list.className = 'ai-advisor-products';

    products.forEach(function (product) {
      var card = document.createElement('a');
      card.className = 'ai-advisor-product-card';
      card.href   = '/products/' + product.handle;
      card.target = '_self'; // même onglet — sessionStorage restaure la conversation au retour

      if (product.image && product.image.url) {
        var img = document.createElement('img');
        img.className  = 'ai-advisor-product-card__img';
        img.src        = product.image.url;
        img.alt        = product.image.altText || product.title;
        img.loading    = 'lazy';
        card.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className   = 'ai-advisor-product-card__img--placeholder';
        placeholder.textContent = '🌸';
        card.appendChild(placeholder);
      }

      var info = document.createElement('div');
      info.className = 'ai-advisor-product-card__info';

      var name = document.createElement('div');
      name.className   = 'ai-advisor-product-card__name';
      name.textContent = product.title;
      info.appendChild(name);

      if (product.price) {
        var price = document.createElement('div');
        price.className   = 'ai-advisor-product-card__price';
        price.textContent = product.price;
        info.appendChild(price);
      }

      card.appendChild(info);

      var badge = document.createElement('span');
      badge.className   = 'ai-advisor-product-card__badge';
      badge.textContent = 'Voir →';
      card.appendChild(badge);

      list.appendChild(card);
    });

    bubble.appendChild(list);
    div.appendChild(bubble);
    messages.appendChild(div);
  }

  // ============================================================
  // Fonctions d'affichage (loggent dans msgLog + sauvegarde)
  // ============================================================
  function appendMessage(role, text, isError) {
    var div = renderMessage(role, text, isError);
    if (!isError) {
      msgLog.push({ type: 'message', role: role, text: text, isError: !!isError });
    }
    scrollToBottom();
    return div;
  }

  function appendProducts(products) {
    renderProduits(products);
    msgLog.push({ type: 'products', products: products });
    scrollToBottom();
    sauvegarderSession(); // sauvegarder immédiatement après rendu des produits
  }

  function appendTyping() {
    var div = document.createElement('div');
    div.className = 'ai-advisor-message ai-advisor-message--bot';
    var typing = document.createElement('div');
    typing.className = 'ai-advisor-typing';
    typing.innerHTML = '<span class="ai-advisor-typing__dot"></span><span class="ai-advisor-typing__dot"></span><span class="ai-advisor-typing__dot"></span>';
    div.appendChild(typing);
    messages.appendChild(div);
    scrollToBottom();
    return div;
  }

  function removeTyping(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // ============================================================
  // Utilitaires
  // ============================================================
  function scrollToBottom() {
    if (messages) messages.scrollTop = messages.scrollHeight;
  }

  function setLoading(state) {
    isLoading = state;
    if (sendBtn) sendBtn.disabled = state;
    if (input)   input.disabled   = state;
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Rendu Markdown sécurisé : gras + liens internes /products/ uniquement
  // Ordre : escape HTML d'abord, puis apply Markdown sur le texte échappé
  function renderMarkdown(str) {
    var escaped = escapeHtml(str);
    // Gras **texte**
    escaped = escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    // Liens Markdown [texte](/products/handle) et [texte](/collections/handle)
    escaped = escaped.replace(
      /\[([^\]]+)\]\((\/(?:products|collections)\/[a-zA-Z0-9_\-]+)\)/g,
      '<a href="$2" class="ai-advisor-inline-link">$1</a>'
    );
    // Sauts de ligne
    escaped = escaped.replace(/\n/g, '<br>');
    return escaped;
  }

  // ============================================================
  // Initialisation — restaurer la session au chargement de page
  // ============================================================

  // Sauvegarder avant toute navigation (clic produit, lien externe, etc.)
  window.addEventListener('beforeunload', function () {
    if (msgLog.length > 0) sauvegarderSession();
  });

  // Restaurer la session et rouvrir le panneau si une conversation existait
  (function init() {
    var raw = null;
    try { raw = sessionStorage.getItem(SESSION_KEY); } catch (e) {}
    if (raw) {
      restaurerSession();
      // Rouvrir le panneau automatiquement pour que l'utilisateur retrouve
      // sa conversation sans avoir à cliquer sur le bouton
      openPanel();
    }
  })();

})();
